import isEmpty from "lodash/isEmpty";
import { useState, useEffect } from "react";
import { AD_PRODUCTS_TYPES } from "../constants";
import { useAppConfig, appConfigActionsTypes } from "../contexts/appConfig";
import { useRotatedAdProductOfType } from "./adProducts";

export default function useSplashScreen() {
  const [appConfigState, appConfigDispatch] = useAppConfig();
  const { adProductSplashScreen } = appConfigState;
  const [splashScreenRotated, setSplashScreenRotated] = useState(false);
  const { adProduct: splashScreen } = useRotatedAdProductOfType(
    AD_PRODUCTS_TYPES.AD_PRODUCT_SPLASH_SCREEN,
  );

  useEffect(() => {
    if (!splashScreenRotated && !isEmpty(splashScreen)) {
      setSplashScreenRotated(true);
    }

    if (
      splashScreenRotated &&
      !isEmpty(splashScreen) &&
      !adProductSplashScreen.seen &&
      !adProductSplashScreen.visible
    ) {
      appConfigDispatch({
        type: appConfigActionsTypes.SET_SPLASH_SCREEN_VISIBLE,
        payload: true,
      });
    }
  }, [
    adProductSplashScreen.seen,
    adProductSplashScreen.visible,
    appConfigDispatch,
    splashScreen,
    splashScreenRotated,
  ]);

  const onLoadComplete = () => {
    setTimeout(
      () =>
        adProductSplashScreen.visible &&
        appConfigDispatch({
          type: appConfigActionsTypes.SET_SPLASH_SCREEN_VISIBLE,
          payload: false,
        }),
      5000,
    );
  };

  return { splashScreen, onLoadComplete };
}
